export const API_BASE = 'https://solmar-api.patient-recipe-50e7.workers.dev';
